import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'uw-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent {

  constructor(
    private readonly _translateService: TranslateService
  ) { }

  toggle(e: Event) {
    e.preventDefault();
    localStorage.setItem('lang', this._translateService.currentLang == 'en' ? 'fr' : 'en');
    window.location.reload();
  }

  readonly currentLanguageIsEnglish = this._translateService.currentLang == "en";
}

@NgModule({
    exports: [
        LanguageSelectorComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        LanguageSelectorComponent
    ]
})
export class LanguageSelectorModule { }
